<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4Nkjtq/tc-custom/9780253109668.jpg?1733103287625" alt="This image is the cover for the book Philosophy, Feminism & Faith, Philosophy of Religion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Philosophy, Feminism & Faith, Philosophy of Religion
      </h1>
      <p class="bookDescription body article font2">
        <p>"The stories are powerful, sometimes heart-rending, sometimes lyrical, but always deeply personal.  And there is some very good philosophizing as part of the bargain." —Merold Westphal</p><p>How can the seemingly separate lives of philosopher, feminist, and follower of a religious tradition come together in one person's life? How does religious commitment affect philosophy or feminism? How does feminism play out in religious or philosophical commitment? Wrestling with answers to these questions, women who balance philosophy, feminism, and faith write about their lives. The voices gathered here from several different traditions—Catholic, Protestant, Quaker, Jewish, and Muslim—represent diverse ethnicities, races, and ages. The challenging and poignant reflections in Philosophy, Feminism, and Faith show how critical thought can successfully mesh with religious faith and social responsibility.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ruth E. Groenhout, Marya Bower
      </h2>
      
      <p class="authorDescription body article"><P>Ruth E. Groenhout teaches in the Department of Philosophy at Calvin College.</P><P>Marya Bower is Associate Professor of Philosophy at Earlham College. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?63c476f2